var render = function render(){var _vm=this,_c=_vm._self._c;return _c('UnidentifiedReturnsListUser',{attrs:{"countFilterParams":_vm.countFilterParams,"filterGetParams":_vm.filterGetParams,"navTabs":_vm.navTabs},on:{"resetFilter":_vm.resetFilter,"showMore":_vm.showMore,"changeFilter":_vm.changeFilter,"reload":_vm.reload,"changeTab":_vm.changeTab}})
}
var staticRenderFns = []

export { render, staticRenderFns }